const app_key = require('airship/modules/app_key')
const request2 = require('airship/modules/request2/index')
const cookie = require('airship/utils/cookie')

const credentials = new Map()

module.exports = getKeymasterCredentials

function getKeymasterCredentials(path, expiry) {
  return new Promise(getCredentials)

  function getCredentials(resolve, reject) {
    const cachedData = credentials.get(path)
    if (cachedData) {
      // Check to see if it has expired.
      if (cachedData.expiresAt < Date.now()) {
        // Cached data is still good. Return it.
        return resolve(cachedData.data)
      }
    }

    // Either we had a cache miss or the expiry is past.
    // Regardless, we need to fetch fresh credentials.
    fetchCredentials(path, expiry)
      .then(data => {
        // `expiry` should be in *seconds* (not milliseconds). Default is 12 hours.
        expiry = expiry || 60 * 60 * 12
        const expiresAt = Date.now() + expiry * 1000

        credentials.set(path, {
          expiresAt: expiresAt,
          data: data
        })

        resolve(data)
      })
      .catch(err => {
        reject(err)
      })
  }
}

function fetchCredentials(path, expiry) {
  const headers = {
    'X-CSRFToken': cookie('csrftoken'),
    'Content-Type': 'application/x-www-form-urlencoded'
  }
  const body = new FormData()

  body.append('expiry', expiry)

  return new Promise((resolve, reject) => {
    request2
      .post({
        headers: headers,
        path: path,
        body: body
      })
      .then(resp => {
        if (resp.statusCode !== 200) {
          return reject(Error(`Got ${resp.statusCode} trying to authenticate`))
        }

        const body = JSON.parse(resp.body)

        resolve({
          'x-ua-keymaster-digest': body.digest,
          'x-ua-keymaster-token': body.token,
          'x-ua-app-key': app_key
        })
      })
      .catch(reject)
  })
}
